angular.module('mtic.components.dashboards.student_general', [
  'mtic.components.modules'
])

angular.module('mtic.components.dashboards.student_general')
.directive('dashboardStudent', function (
  EventManager,
  StudentDataService,
  $log,
  $timeout,
  language,
  TIMING_CONSTANTS,
  $q,
  $rootScope
) {

  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope) {

      // event manager
      var eventManager = new EventManager("studentDashboard", scope);
      scope.isClassSelected = false;
      scope.isLeaderboardActive = false;

      eventManager.broadcast('language:init', language.getCurrentSelectedLanguage());

      scope.$watch('isClassSelected', function(){
        if(scope.isClassSelected){
          $rootScope.pageView = 'student-class-view';
        }
        else{
          $rootScope.pageView = 'student-classes-view';
        }
        $rootScope.sidebarExpanded = false;
      });

      scope.selectClassroom = function(class_group_id){
        if(!class_group_id){
          return;
        }
        scope.isLeaderboardActive = false;
        scope.isClassSelected = true;
        StudentDataService.setActiveClassroom(class_group_id);
        eventManager.broadcast('student:cycle:open');
      }

      eventManager.listen('navbar:my-classes:click', function (e) {
        scope.isClassSelected = false;
        scope.moduleMapData = null;
        scope.isLeaderboardActive = false;
      });

      eventManager.listen('student:leaderboard:open', function (e, data) {
        // $log.log('leaderboard open', data)
        StudentDataService.leaderboardConfig = {
          classId: data.classId,
          classType: data.classType,
          classCountry: data.classCountry,
        }
        scope.isLeaderboardActive = true;
        scope.isClassSelected = true;
        $rootScope.sidebarExpanded = false;
      });

      eventManager.listen('post-student-cycle-prompt-complete', function (e, args) {
        scope.selectClassroom(args);
      });

    }
  }
})
